import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoutIco from "../../../assets/icons/LogoutIco";
import CommonButton from "../../../component/Button";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import DialogCandidateHub from "../../jobs/jobs-candidate/components/DialogCandidateHub";
import { CustomizeSpan } from "../../jobs/style";
import OurPlan from "./OurPlan";
import {
  AllPlan,
  PlanBillingCall,
} from "../../../redux/action/OrganizationSetup";
import SnackBar from "../../../component/SnackBar";
import { useDispatch } from "react-redux";
import { platformBlackLogo } from "../../../utils/logo";

export default function PlanExpired() {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const dispatch = useDispatch();
  const [logout, setLogout] = useState({
    logoutLoading: false,
    open: false,
    disabled: false,
    noLoading: false,
  });
  const [checked, setChecked] = useState(false);

  const URL = process.env.REACT_APP_WEBSITE_URL;
  const navigate = useNavigate();

  const [planData, setPlanData] = useState({ loading: true });

  const handleExpand = (value) => {
    setPlanData((prev) => ({
      ...prev,
      all_plans: prev.all_plans.map((item, index) =>
        index === value
          ? {
              ...item,
              expand:
                item.expand === "View Details"
                  ? "Hide Details"
                  : "View Details",
            }
          : item
      ),
    }));
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const FooterLogout = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={logout.disabled}
        loading={logout.noLoading}
        onClick={() => {
          setLogout((prev) => ({
            ...prev,
            disabled: true,
            noLoading: true,
          }));
          setTimeout(() => {
            handleLogout();
          }, 1000);
        }}
      />
      <CommonButton
        value={"Logout"}
        width={"100%"}
        variant="contained"
        color="white"
        background="#D92D20"
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={logout.disabled}
        loading={logout.logoutLoading}
        onClick={() => {
          setLogout((prev) => ({
            ...prev,
            logoutLoading: true,
            disabled: true,
          }));
          setTimeout(() => {
            localStorage.clear();
            dispatch({ type: "RESET_ALL" });
            navigate("/auth/login");
          }, 1000);
        }}
      />
    </CommonGrid2>
  );

  const handleLogout = () => {
    setLogout({
      noLoading: false,
      open: false,
      logoutLoading: false,
      disabled: false,
    });
  };

  const handleClickOpen = () => {
    window.open(`${URL}/contact-us`, "_blank", "noopener,noreferrer");
  };

  const handleClickStripeOpen = async (item, index, checked) => {
    setPlanData((prev) => ({
      ...prev,
      all_plans: prev.all_plans.map((_, i) =>
        i === index ? { ..._, disabled: true, loading: true } : _
      ),
    }));
    try {
      let payload = {
        plan: checked ? item.name + " Yearly" : item.name + " Monthly",
      };
      let data = await PlanBillingCall(payload);
      setPlanData((prev) => ({
        ...prev,
        all_plans: prev.all_plans.map((_, i) => ({
          ..._,
          disabled: false,
          loading: false,
        })),
      }));

      window.open(data?.data?.url, "_blank", "noopener,noreferrer");
    } catch (error) {
      setPlanData((prev) => ({
        ...prev,
        all_plans: prev.all_plans.map((_, i) => ({
          ..._,
          disabled: false,
          loading: false,
        })),
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const functionCall = async () => {
    try {
      const data = await AllPlan();
      setPlanData({ ...data, loading: false });
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
    }
  };
  useEffect(() => {
    functionCall();
  }, []);

  return (
    <CustomDiv
      padding="2rem"
      sx={{
        width: {
          xs: "100%",
          xl: "90%",
          md: "90%",
        },
        margin: "auto auto",
      }}
    >
      <CommonGrid2
        gap={"2rem"}
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        alignItems={"center"}
      >
        <CustomDiv width="fit-content">
          {platformBlackLogo({height: "50px"})}
        </CustomDiv>
        <CommonGrid2 display={"flex"} gap={"2rem"}>
          <CommonButton
            value={"Contact Us"}
            padding={"10px"}
            variant="outlined"
            color="#344054"
            fontWeight={"700"}
            border={"transparent"}
            width={"150px"}
            height="fit-content"
            onClick={() => handleClickOpen()}
          />
          <CommonButton
            value={"Logout"}
            padding={"10px"}
            width={"150px"}
            fontWeight={"700"}
            height="fit-content"
            onClick={() => {
              setLogout((prev) => ({
                ...prev,
                open: true,
              }));
            }}
          />
        </CommonGrid2>
      </CommonGrid2>
      <CommonGrid2
        padding={"2rem"}
        background="#EBF1F4"
        borderRadius={"10px"}
        marginTop={"6rem"}
        display={"flex"}
        flexDirection={"column"}
        gap={"1rem"}
      >
        <Typography
          variant="h1"
          color="#8396A8"
          fontWeight={700}
          sx={{
            background: "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          The trial duration has been completed !
        </Typography>
        <Typography variant="h2" color="#A9B4BE" fontWeight={700}>
          To continue using TalAiro, you need to upgrade your Plan
        </Typography>
      </CommonGrid2>
      <OurPlan
        monthData={planData}
        handleChange={handleChange}
        handleExpand={handleExpand}
        handleClickStripeOpen={handleClickStripeOpen}
        checked={checked}
        loading={planData.loading}
      />

      <DialogCandidateHub
        open={logout.open}
        centerIcon={<LogoutIco />}
        handleClose={handleLogout}
        footer={<FooterLogout />}
        title="Are you want to logout?"
        titlepadding={"16px 0px 16px"}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
